const Anhui = require('./an_hui_geo');
const Aomen = require('./ao_men_geo');
const Beijing = require('./bei_jing_geo');
const Chongqing = require('./chong_qing_geo');
const Fujian = require('./fu_jian_geo');
const Gansu = require('./gan_su_geo');
const Guangdong = require('./guang_dong_geo');
const Guangxi = require('./guang_xi_geo');
const Guizhou = require('./gui_zhou_geo');
const Hainan = require('./hai_nan_geo');
const Hebei = require('./he_bei_geo');
const Henan = require('./he_nan_geo');
const Heilongjiang = require('./hei_long_jiang_geo');
const Hubei = require('./hu_bei_geo');
const Hunan = require('./hu_nan_geo');
const Jilin = require('./ji_lin_geo');
const Jiangsu = require('./jiang_su_geo');
const Jiangxi = require('./jiang_xi_geo');
const Liaoning = require('./liao_ning_geo');
const Neimenggu = require('./nei_meng_gu_geo');
const Ningxia = require('./ning_xia_geo');
const Qinghai = require('./qing_hai_geo');
const Shandong = require('./shan_dong_geo');
const Shanxi_1 = require('./shan_xi_1_geo');
const Shanxi_3 = require('./shan_xi_3_geo');
const Shanghai = require('./shang_hai_geo');
const Sichuan = require('./si_chuan_geo');
const Taiwan = require('./tai_wan_geo');
const Tianjin = require('./tian_jin_geo');
const Xizang = require('./xi_zang_geo');
const Xianggang = require('./xiang_gang_geo');
const Xinjiang = require('./xin_jiang_geo');
const Yunnan = require('./yun_nan_geo');
const Zhejiang = require('./zhe_jiang_geo');

module.exports = {
  Anhui, Aomen, Beijing, Chongqing, Fujian, Guizhou, Guangxi, Guangdong,
  Gansu, Hunan, Hubei, Heilongjiang, Hebei, Henan, Hainan, Jiangxi, Jiangsu, Jilin,
  Liaoning, Ningxia, Neimenggu, Qinghai, Sichuan, Shanghai, Shandong, Shanxi_1,
  Shanxi_3, Tianjin, Taiwan, Xinjiang, Xianggang, Xizang, Yunnan, Zhejiang
};



// WEBPACK FOOTER //
// ./src/province/index.js